module.exports = __webpack_public_path__ + "static/media/search.ebd10510.svg";